import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "badge"
}
const _hoisted_2 = {
  key: 1,
  class: "nb-dot alert"
}
const _hoisted_3 = {
  key: 2,
  class: "nb-dot update"
}
const _hoisted_4 = { class: "np-hdr" }
const _hoisted_5 = { class: "np-tabs" }
const _hoisted_6 = {
  key: 0,
  class: "pill"
}
const _hoisted_7 = {
  key: 0,
  class: "pill"
}
const _hoisted_8 = {
  class: "np-actions",
  style: {"display":"flex","gap":"4px","align-items":"center"}
}
const _hoisted_9 = ["aria-disabled", "title"]
const _hoisted_10 = { class: "np-list" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "np-title" }
const _hoisted_13 = { class: "np-msg" }
const _hoisted_14 = { class: "np-meta" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 0,
  class: "np-empty"
}
const _hoisted_20 = {
  key: 1,
  class: "np-loadmore"
}
const _hoisted_21 = { class: "np-hdr" }
const _hoisted_22 = { class: "np-tabs" }
const _hoisted_23 = {
  key: 0,
  class: "pill"
}
const _hoisted_24 = {
  key: 0,
  class: "pill"
}
const _hoisted_25 = {
  class: "np-actions",
  style: {"display":"flex","gap":"4px","align-items":"center"}
}
const _hoisted_26 = ["aria-disabled", "title"]
const _hoisted_27 = { class: "np-list" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "np-title" }
const _hoisted_30 = { class: "np-msg" }
const _hoisted_31 = { class: "np-meta" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = {
  key: 0,
  class: "np-empty"
}
const _hoisted_37 = {
  key: 1,
  class: "np-loadmore"
}

import { bootstrapNotifications, fetchLatest, markAllAsRead, markOneAsRead, setMaxLimit, useNotifications } from "@/composables/useNotifications";
	import router from "@/router";
	import { Bell as BellIcon, CheckCheck as MarkAsReadIcon, Mail as MailIcon, MailOpen as MailOpenIcon } from "lucide-vue-next";
	import { computed, inject, onMounted, onUnmounted, ref, type Ref } from "vue";

	const PANEL_WIDTH = 320;

	/** Tabs */
	
export default /*@__PURE__*/_defineComponent({
  __name: 'NotificationBell',
  props: {
    placement: { default: "sidebar" }
  },
  setup(__props: any) {

	const props = __props;
	const placement = props.placement;

	const { state, toggleOpen, close } = useNotifications();
	const items = computed(() => state.items);
	const unread = computed(() => state.unread);
	const open = computed(() => state.open);

	/** ▸ Limite globale fetch lato server */
	const currentLimit = ref(10); // es. parti da 10
	const unreadTotal = computed<number>(() => (state as any).unreadCount ?? unread.value ?? 0);

	/** ▸ Limiti di visualizzazione locali (slicing solo UI) */
	const alertsVisible = ref(5);
	const updatesVisible = ref(5);

	// iniettati
	const isDesktop = inject<Ref<boolean> | undefined>("isDesktop");
	const sidebarOpen = inject<Ref<boolean> | undefined>("isSidebarOpen");

	const wrap = ref<HTMLDivElement | null>(null);
	const view = ref<"alerts" | "updates">("alerts");

	/** Liste base (sul dataset fetchato) */
	const alerts = computed(() => items.value.filter((n) => n?.severity === "error" || n?.severity === "warning" || n?.payload?.kind === "alert"));
	const updates = computed(() => items.value.filter((n) => !alerts.value.some((a) => a.id === n.id)));

	/** Liste mostrate (slicing per-tab) */
	const alertsShown = computed(() => alerts.value.slice(0, alertsVisible.value));
	const updatesShown = computed(() => updates.value.slice(0, updatesVisible.value));
	const currentList = computed(() => (view.value === "alerts" ? alertsShown.value : updatesShown.value));

	// NON LETTI caricati (dataset corrente)
	const unreadLoaded = computed(() => items.value.filter((n) => !n.is_read).length);
	const unreadLoadedAlert = computed(() => alerts.value.filter((n) => !n.is_read).length);
	const unreadLoadedUpds = computed(() => updates.value.filter((n) => !n.is_read).length);

	// NON LETTI visibili nella lista mostrata
	const unreadShownAlert = computed(() => alertsShown.value.filter((n) => !n.is_read).length);
	const unreadShownUpds = computed(() => updatesShown.value.filter((n) => !n.is_read).length);

	// Posso mostrare di più in **questa tab** senza rifetchare?
	// (solo se esistono altri NON LETTI già fetchati ma ancora nascosti)
	const canShowMoreAlertsLocal = computed(() => unreadLoadedAlert.value > unreadShownAlert.value);
	const canShowMoreUpdatesLocal = computed(() => unreadLoadedUpds.value > unreadShownUpds.value);

	// Ha senso chiedere più dati al server? (ci sono NON LETTI fuori dal dataset)
	const canFetchMoreServer = computed(() => items.value.length === currentLimit.value && unreadTotal.value > unreadLoaded.value);

	// Stato bottone per tab corrente (prima prova ad allargare localmente gli UNREAD,
	// altrimenti – se esistono altri non letti fuori dal dataset – abilita fetch)
	const canLoadMoreAlerts = computed(() => canShowMoreAlertsLocal.value || canFetchMoreServer.value);
	const canLoadMoreUpdates = computed(() => canShowMoreUpdatesLocal.value || canFetchMoreServer.value);

	const isMarkAllDisabled = computed(() => (view.value === "alerts" ? unreadLoadedAlert.value : unreadLoadedUpds.value) === 0);

	const markAllTitle = computed(() =>
		isMarkAllDisabled.value ? (view.value === "alerts" ? "Nessun avviso da risolvere" : "Nessun aggiornamento da leggere") : view.value === "alerts" ? "Segna tutti come già risolti" : "Segna tutti come già letti"
	);

	const isAlert = (n: any) => n?.severity === "error" || n?.severity === "warning" || n?.payload?.kind === "alert";

	/** Considera "risolto" se è stato letto o ha uno di questi flag di risoluzione */
	const isResolved = (n: any) => !!(n?.is_read || n?.resolved || n?.payload?.resolved || n?.status === "resolved" || n?.graph_status === "ok");

	const unresolvedAlerts = computed(() => items.value.filter((n) => isAlert(n) && !isResolved(n)));

	const unresolvedAlertsCount = computed(() => unresolvedAlerts.value.length);

	const unreadUpdatesCount = computed(() => updates.value.filter((n) => !n.is_read).length);

	/** (opzionale) severità peggiore per colorare il dot */
	const worstUnresolvedSeverity = computed<"error" | "warning" | null>(() => {
		if (unresolvedAlerts.value.some((n) => n.severity === "error")) return "error";
		if (unresolvedAlerts.value.some((n) => n.severity === "warning")) return "warning";
		return null;
	});

	function onBellClick() {
		toggleOpen();
	}

	/** Handler “Carica altre” per tab corrente */
	async function loadMore() {
		if (view.value === "alerts") {
			if (canShowMoreAlertsLocal.value) {
				alertsVisible.value += 5;
				return;
			}
		} else {
			if (canShowMoreUpdatesLocal.value) {
				updatesVisible.value += 5;
				return;
			}
		}
		// qui non abbiamo più elementi locali → chiediamo al server altri item
		currentLimit.value += 10; // fetcha altri 10 (o 20 se preferisci)
		setMaxLimit(currentLimit.value);
		await fetchLatest({ limit: currentLimit.value });
		// piccolo boost al visibile per la tab corrente (in caso arrivino nuovi elementi della categoria)
		if (view.value === "alerts") alertsVisible.value += 5;
		else updatesVisible.value += 5;
	}

	/** Segna letti SOLO quelli della vista corrente (alert/update) */
	async function markAllInCurrentViewAsRead() {
		const base = view.value === "alerts" ? alertsShown.value : updatesShown.value;
		const ids = base.filter((n) => !n.is_read).map((n) => n.id);
		if (!ids.length) return;
		await Promise.all(ids.map((id) => markOneAsRead(id)));
		await fetchLatest({ limit: currentLimit.value });
	}

	function formatWhen(n: any) {
		const ts = n.createdAt ?? n.created_at;
		try {
			return ts ? new Date(ts).toLocaleString() : "";
		} catch {
			return "";
		}
	}

	async function handleItemClick(n: any) {
		if (!n.is_read) await markOneAsRead(n.id);
		if (n.graph_id) return;
	}

	/** Floating position */
	const floatStyle = computed(() => {
		const bellEl = wrap.value?.querySelector(".nb-bell") as HTMLElement | null;
		if (!bellEl) return { position: "fixed", top: "56px", right: "16px", zIndex: 20010 } as any;
		const r = bellEl.getBoundingClientRect();
		const gap = 8;
		let left = Math.round(r.right - PANEL_WIDTH);
		left = Math.max(8, Math.min(left, window.innerWidth - PANEL_WIDTH - 8));
		const top = Math.round(r.bottom + gap);
		return { position: "fixed", left: `${left}px`, top: `${top}px`, zIndex: 20010 } as any;
	});

	function onBodyClick() {
		close();
	}

	async function handleMarkAllGlobal() {
		try {
			await markAllAsRead();
			// refresh lista
			await fetchLatest({ limit: currentLimit.value });
		} catch (e) {
			console.error("Errore markAllAsRead:", e);
		}
	}

	onMounted(async () => {
		// Imposta il limite solo se il singleton non è ancora stato inizializzato:
		// evita di abbassare un limit già alzato da AlertsPage o da un altro componente.
		if (!state.ready) setMaxLimit(currentLimit.value);
		// fetchLatest({ limit: currentLimit.value });
		await bootstrapNotifications();

		document.body.addEventListener("click", onBodyClick);
	});
	onUnmounted(() => {
		document.body.removeEventListener("click", onBodyClick);
	});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["nb-wrap", [`nb-${_unref(placement)}`]]),
    ref_key: "wrap",
    ref: wrap,
    onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createElementVNode("div", {
      class: "nb-bell",
      onClick: onBellClick,
      title: 'Notifiche'
    }, [
      _createVNode(_unref(BellIcon), { class: "ico" }),
      (unread.value > 0)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(unread.value > 99 ? "99+" : unread.value), 1))
        : _createCommentVNode("", true),
      (unresolvedAlertsCount.value > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2))
        : (unreadUpdatesCount.value > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3))
          : _createCommentVNode("", true)
    ]),
    (open.value && _unref(placement) === 'sidebar')
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["nb-panel is-fixed", { 'desk-open': _unref(isDesktop)?.valueOf && _unref(sidebarOpen)?.valueOf }]),
          ref: "panel"
        }, [
          _createElementVNode("header", _hoisted_4, [
            _createElementVNode("nav", _hoisted_5, [
              _createElementVNode("button", {
                class: _normalizeClass(["np-tab", { active: view.value === 'alerts' }]),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (view.value = 'alerts')),
                title: "Avvisi"
              }, [
                _cache[8] || (_cache[8] = _createTextVNode(" Avvisi ", -1)),
                (unreadLoadedAlert.value > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(unreadLoadedAlert.value), 1))
                  : _createCommentVNode("", true)
              ], 2),
              _createElementVNode("button", {
                class: _normalizeClass(["np-tab", { active: view.value === 'updates' }]),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (view.value = 'updates')),
                title: "Aggiornamenti"
              }, [
                _cache[9] || (_cache[9] = _createTextVNode(" Aggiornamenti ", -1)),
                (unreadLoadedUpds.value > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(unreadLoadedUpds.value), 1))
                  : _createCommentVNode("", true)
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_8, [
              (unread.value > 0)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "np-act",
                    title: "Segna TUTTE come lette",
                    onClick: handleMarkAllGlobal
                  }, [
                    _createVNode(_unref(MarkAsReadIcon), { class: "ico" })
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                class: _normalizeClass(["np-act", { disabled: isMarkAllDisabled.value }]),
                "aria-disabled": isMarkAllDisabled.value,
                title: markAllTitle.value,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (!isMarkAllDisabled.value && markAllInCurrentViewAsRead()))
              }, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(isMarkAllDisabled.value ? _unref(MailIcon) : _unref(MailOpenIcon)), { class: "ico" }))
              ], 10, _hoisted_9)
            ])
          ]),
          _createElementVNode("ul", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentList.value, (n) => {
              return (_openBlock(), _createElementBlock("li", {
                key: n.id,
                class: _normalizeClass([
						'np-item',
						n.severity,
						{
							update: !isAlert(n),
							unread: !isResolved(n), // dot e stile “unread” solo se NON risolto
							'n-read-flag': isResolved(n), // stile neutro se risolto/letto
							resolved: isResolved(n),
						},
					]),
                onClick: ($event: any) => (handleItemClick(n))
              }, [
                _createElementVNode("div", _hoisted_12, _toDisplayString(n.title || "Aggiornamento"), 1),
                _createElementVNode("div", _hoisted_13, _toDisplayString(n.message || "—"), 1),
                _createElementVNode("div", _hoisted_14, [
                  (_unref(state).isAdmin)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _cache[10] || (_cache[10] = _createTextVNode(" · ", -1)),
                        (n.email)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(n.email), 1))
                          : _createCommentVNode("", true),
                        (n.graph_name || n.graph_id)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                              _createTextVNode(" · " + _toDisplayString(n.graph_name || "#" + n.graph_id), 1),
                              (n.graph_status)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_17, " (" + _toDisplayString(n.graph_status) + ")", 1))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true),
                  _createTextVNode(" · " + _toDisplayString(formatWhen(n)), 1)
                ]),
                (!n.is_read)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "n-btn",
                      onClick: _withModifiers(($event: any) => (_unref(markOneAsRead)(n.id)), ["stop"])
                    }, _toDisplayString(view.value === "alerts" ? "Segna come già risolto" : "Segna come già letto"), 9, _hoisted_18))
                  : _createCommentVNode("", true)
              ], 10, _hoisted_11))
            }), 128)),
            (currentList.value.length === 0)
              ? (_openBlock(), _createElementBlock("li", _hoisted_19, _toDisplayString(view.value === "alerts" ? "Nessun avviso" : "Nessun aggiornamento"), 1))
              : _createCommentVNode("", true),
            (view.value === 'alerts' ? canLoadMoreAlerts.value : canLoadMoreUpdates.value)
              ? (_openBlock(), _createElementBlock("li", _hoisted_20, [
                  _createElementVNode("button", {
                    class: "np-loadmore-btn",
                    onClick: _withModifiers(loadMore, ["stop"])
                  }, " Carica altri " + _toDisplayString(view.value === "alerts" ? "avvisi" : "aggiornamenti"), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ], 2))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (open.value && _unref(placement) !== 'sidebar')
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "nb-panel is-floating",
            style: _normalizeStyle(floatStyle.value),
            ref: "panel",
            onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("header", _hoisted_21, [
              _createElementVNode("nav", _hoisted_22, [
                _createElementVNode("button", {
                  class: _normalizeClass(["np-tab", { active: view.value === 'alerts' }]),
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (view.value = 'alerts')),
                  title: "Avvisi"
                }, [
                  _cache[11] || (_cache[11] = _createTextVNode(" Avvisi ", -1)),
                  (unreadLoadedAlert.value > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(unreadLoadedAlert.value), 1))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("button", {
                  class: _normalizeClass(["np-tab", { active: view.value === 'updates' }]),
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (view.value = 'updates')),
                  title: "Aggiornamenti"
                }, [
                  _cache[12] || (_cache[12] = _createTextVNode(" Aggiornamenti ", -1)),
                  (unreadLoadedUpds.value > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(unreadLoadedUpds.value), 1))
                    : _createCommentVNode("", true)
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_25, [
                (unread.value > 0)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "np-act",
                      title: "Segna TUTTE come lette",
                      onClick: handleMarkAllGlobal
                    }, [
                      _createVNode(_unref(MarkAsReadIcon), { class: "ico" })
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  class: _normalizeClass(["np-act", { disabled: isMarkAllDisabled.value }]),
                  "aria-disabled": isMarkAllDisabled.value,
                  title: markAllTitle.value,
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (!isMarkAllDisabled.value && markAllInCurrentViewAsRead()))
                }, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(isMarkAllDisabled.value ? _unref(MailIcon) : _unref(MailOpenIcon)), { class: "ico" }))
                ], 10, _hoisted_26)
              ])
            ]),
            _createElementVNode("ul", _hoisted_27, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentList.value, (n) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: n.id,
                  class: _normalizeClass([
							'np-item',
							n.severity,
							{
								update: !isAlert(n),
								unread: !isResolved(n), // dot e stile “unread” solo se NON risolto
								'n-read-flag': isResolved(n), // stile neutro se risolto/letto
								resolved: isResolved(n),
							},
						]),
                  onClick: ($event: any) => (handleItemClick(n))
                }, [
                  _createElementVNode("div", _hoisted_29, _toDisplayString(n.title || "Aggiornamento"), 1),
                  _createElementVNode("div", _hoisted_30, _toDisplayString(n.message || "-"), 1),
                  _createElementVNode("div", _hoisted_31, [
                    (_unref(state).isAdmin)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _cache[13] || (_cache[13] = _createTextVNode(" · ", -1)),
                          (n.email)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(n.email), 1))
                            : _createCommentVNode("", true),
                          (n.graph_name || n.graph_id)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_33, [
                                _createTextVNode(" · " + _toDisplayString(n.graph_name || "#" + n.graph_id), 1),
                                (n.graph_status)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_34, " (" + _toDisplayString(n.graph_status) + ")", 1))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true),
                    _createTextVNode(" · " + _toDisplayString(formatWhen(n)), 1)
                  ]),
                  (!n.is_read)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "n-btn",
                        onClick: _withModifiers(($event: any) => (_unref(markOneAsRead)(n.id)), ["stop"])
                      }, _toDisplayString(view.value === "alerts" ? "Segna come già risolto" : "Segna come già letto"), 9, _hoisted_35))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_28))
              }), 128)),
              (currentList.value.length === 0)
                ? (_openBlock(), _createElementBlock("li", _hoisted_36, _toDisplayString(view.value === "alerts" ? "Nessun avviso" : "Nessun aggiornamento"), 1))
                : _createCommentVNode("", true),
              (view.value === 'alerts' ? canLoadMoreAlerts.value : canLoadMoreUpdates.value)
                ? (_openBlock(), _createElementBlock("li", _hoisted_37, [
                    _createElementVNode("button", {
                      class: "np-loadmore-btn",
                      onClick: _withModifiers(loadMore, ["stop"])
                    }, " Carica altri " + _toDisplayString(view.value === "alerts" ? "avvisi" : "aggiornamenti"), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 4))
        : _createCommentVNode("", true)
    ]))
  ], 2))
}
}

})